import React, { PureComponent } from "react";
import { goBack, push } from "react-router-redux";
import { connect } from "react-redux";
import classnames from "classnames";
import moment from "moment";
import _ from "i18n";

import { initCapacityPlaningProduction } from "Actions";
import { fetchSettingCollaborators, updateSettingsCollaborator } from "Thunks";
import { onSuccess, onError } from "Utils";

import { SettingIcon, PencilIcon } from "../Common/Icons";
import NotFoundV2 from "../NotFound/NotFoundV2";
import TTPModal from "../Common/Modal/TTPModal";
import { Button, Tooltip } from "antd";

import SettingPageHeader from "../Common/PageHeader/SettingPageHeader";
import LocalizationSettingContent from "./LocalizationSettingContent";
import UpdateCollaboratorContent from "./UpdateCollaboratorContent";
import RegimeSettingContent from "./RegimeSettingContent";
import RoleSettingContent from "./RoleSettingContent";

import styles from "./CollaboratorSettings.local.scss";
import HolidayTypesSettingContent from "./HolidayTypesSettingContent";
import CollaboratorSettingFilter from "./CollaboratorSettingFilter";

const daysOfWeek = ["monday", "tuesday", "wednesday", "thursday", "friday"];
const years = [moment().year() - 1, moment().year(), moment().year() + 1];

class CollaboratorSetting extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      filterFormIsVisible: false,
      yearDivIsVisible: false,
      year: moment().year(),
      expandedKeys: [],
      loading: false,
      selectedCollaborator: null
    };
  }

  componentWillUnmount() {
    clearTimeout(this.intervalID);
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearSelect.bind(this)
    );
    const { dispatch } = this.props;
    dispatch(initCapacityPlaningProduction());
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleRedirectBack = () => {
    const { breadCrumb } = this.props;
    if (breadCrumb.url != null) {
      this.props.dispatch(push(breadCrumb.url));
    } else {
      this.props.dispatch(goBack());
    }
  };
  handleCalculateHolidays = (collaborator, id) => {
    let sum = 0;

    collaborator.holidayTypes.forEach(item => {
      if (item.id !== id) {
        sum = parseInt(sum, 10) + parseInt(item.nbrOfDays, 10);
      }
    });
    return sum;
  };

  renderCollaboratorList = () => {
    const { filteredData, settingSuggestions, erpData } = this.props;
    const data = filteredData ? filteredData : [];

    let erpCollaborators = erpData && erpData.items.collaborators;
    const dataErp = erpCollaborators ? erpCollaborators : [];
    return data.length === 0 ? (
      <NotFoundV2 text={_("noCollaboratorsMatches")} buttonIgnored={true} />
    ) : (
      <div>
        <div className={styles.divBackground}>
          <div className={styles.firstBackground} />
          <div className={styles.secondBackground} />
        </div>
        <div
          className="rmodal__center"
          style={{
            overflowX: "scroll",
            overflowY: "auto",
            height: "775px"
          }}
        >
          <table className={styles.setting_table}>
            <thead key={"thead"}>
              <tr>
                <th
                  style={{
                    minWidth: "190px",
                    position: "sticky",
                    left: "0px",
                    zIndex: "1"
                  }}
                >
                  {_("name")}
                </th>
                <th style={{ minWidth: "150px" }}>
                  {_("localisation")}
                  <div onClick={() => this.handleDisplayLocalizationModal()}>
                    <SettingIcon fill="#3C4E64" />
                  </div>
                </th>
                <th style={{ minWidth: "180px" }}>
                  {_("regime")}
                  <div onClick={() => this.handleDisplayRegimeModal()}>
                    <SettingIcon fill="#3C4E64" />
                  </div>
                </th>
                <th style={{ minWidth: "150px" }}>
                  {_("roleOnFolder")}
                  {/* <div onClick={() => this.handleDisplayRoleModal()}>
                    <SettingIcon fill="#3C4E64" />
                  </div> */}
                </th>
                <th style={{ minWidth: "180px" }}>{_("Partner/Binômes")}</th>
                <th style={{ minWidth: "180px" }}>
                  {_("Congés")}
                  <div
                    onClick={() => this.handleDisplayHolidayTypeModal()}
                    style={{
                      float: "right",
                      cursor: "pointer"
                    }}
                  >
                    <SettingIcon fill="#3C4E64" />
                  </div>
                </th>

                <th style={{ minWidth: "180px" }}>{_("annualCapacity")}</th>
                <th style={{ minWidth: "180px" }}>{_("NFHr")}</th>
                <th
                  style={{
                    position: "sticky",
                    right: "0px",
                    zIndex: "1"
                  }}
                />
              </tr>
            </thead>
            <tbody key={"tbody"}>
              {data.map((collaborator, k) => {
                return (
                  <tr key={collaborator.id}>
                    <td
                      style={{
                        background: k % 2 ? "#f8f9fa" : "#f5f6f7",
                        position: "sticky",
                        left: "0px",
                        zIndex: "2"
                      }}
                    >
                      <div className={styles.name_label}>
                        {collaborator.name}
                        {dataErp.map((erp, i) => {
                          return erp[collaborator.id] &&
                            erp[collaborator.id].erpId ? (
                            <Tooltip
                              key={i}
                              placement="right"
                              title={
                                <div>
                                  <p>
                                    {_("importedFrom")} :{" "}
                                    {erp[collaborator.id].erpLabel}
                                  </p>
                                  <p>
                                    {_("identifier")} :{" "}
                                    {erp[collaborator.id].erpId}
                                  </p>
                                </div>
                              }
                            >
                              {" "}
                              <img
                                src="/img/icons/info.svg"
                                alt="text"
                                className={styles.img_info}
                              />{" "}
                            </Tooltip>
                          ) : (
                            ""
                          );
                        })}
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("arrivalDate")}:{" "}
                          {collaborator.arrivalDate
                            ? moment(
                                collaborator.arrivalDate,
                                "YYYY-MM-DD hh:mm:ss"
                              ).format("Y-MM-DD")
                            : "-"}
                        </div>
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("departureDate")}:{" "}
                          {collaborator.departureDate ? (
                            <div
                              style={{
                                position: "absolute",
                                display: "contents",
                                color:
                                  moment(
                                    collaborator.departureDate,
                                    "YYYY-MM-DD hh:mm:ss"
                                  ).format("Y") < this.state.year
                                    ? "red"
                                    : ""
                              }}
                            >
                              {moment(
                                collaborator.departureDate,
                                "YYYY-MM-DD hh:mm:ss"
                              ).format("Y-MM-DD")}
                            </div>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("zone")} :{" "}
                          {settingSuggestions.data.zones &&
                          settingSuggestions.data.zones.find(
                            obj => obj.id === collaborator.zone
                          )
                            ? settingSuggestions.data.zones.find(
                                obj => obj.id === collaborator.zone
                              ).label
                            : "-"}
                        </div>
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("bu")} :{" "}
                          {settingSuggestions.data.bus &&
                          settingSuggestions.data.bus.find(
                            obj => obj.id === collaborator.bu
                          )
                            ? settingSuggestions.data.bus.find(
                                obj => obj.id === collaborator.bu
                              ).label
                            : "-"}
                        </div>
                      </div>
                    </td>
                    <td style={{ minWidth: "144px" }}>
                      {settingSuggestions.data.regimes &&
                      settingSuggestions.data.regimes.find(
                        obj => obj.id === collaborator.regime
                      )
                        ? settingSuggestions.data.regimes.find(
                            obj => obj.id === collaborator.regime
                          ).label
                        : "-"}

                      <div className={classnames("row", styles.days_content)}>
                        {daysOfWeek.map(i => (
                          <div key={`tool-${i}`}>
                            {collaborator.workingHours[i] > 0 ? (
                              <Tooltip
                                placement="bottom"
                                title={
                                  collaborator.workingHours[i]
                                    ? collaborator.workingHours[i].split(
                                        "."
                                      )[0] +
                                      " h " +
                                      (collaborator.workingHours[i].split(
                                        "."
                                      )[0].length < 1
                                        ? "0" +
                                          collaborator.workingHours[i].split(
                                            "."
                                          )[1]
                                        : collaborator.workingHours[i].split(
                                            "."
                                          )[1])
                                    : "00h00"
                                }
                              >
                                <div
                                  className={styles.daysList}
                                  style={{
                                    color: "#3c4e64",
                                    border: "0.5px solid #18a0fb"
                                  }}
                                >
                                  {_(i).substring(0, 2)}
                                </div>
                              </Tooltip>
                            ) : (
                              <div className={styles.daysList}>
                                {_(i).substring(0, 2)}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </td>
                    <td>
                      {settingSuggestions.data.roles &&
                      settingSuggestions.data.roles.find(
                        obj => obj.id === collaborator.role
                      )
                        ? _(
                            settingSuggestions.data.roles.find(
                              obj => obj.id === collaborator.role
                            ).label === "manager"
                              ? "folderManager"
                              : settingSuggestions.data.roles.find(
                                  obj => obj.id === collaborator.role
                                ).label
                          )
                        : "-"}
                    </td>
                    <td>
                      <div className={classnames("row")}>
                        <div>
                          {_("Partner")}:{" "}
                          {collaborator.partner_name ? (
                            <span>{collaborator.partner_name}</span>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                      <div className={classnames("row")}>
                        <div className={styles.label}>
                          {_("Binômes")}:{" "}
                          {collaborator.backup &&
                          collaborator.backup.length > 0 ? (
                            <ul>
                              {collaborator.backup.map((binomeId, index) => {
                                const binome = data.find(
                                  c => c.id === binomeId
                                );
                                return (
                                  <li key={binomeId}>
                                    {binome ? binome.name : binomeId}
                                  </li>
                                );
                              })}
                            </ul>
                          ) : (
                            "-"
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {settingSuggestions.data.holidayTypes &&
                          settingSuggestions.data.holidayTypes.find(
                            obj => obj.id === 1
                          )
                            ? settingSuggestions.data.holidayTypes.find(
                                obj => obj.id === 1
                              ).label
                            : ""}
                          {" : "}
                          {collaborator.holidayTypes.length > 0
                            ? collaborator.holidayTypes.map(
                                item => (item.id === 1 ? item.nbrOfDays : "")
                              )
                            : 0}
                          {_("day").substring(0, 1)}
                        </div>
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("others")}
                          {" : "}
                          {this.handleCalculateHolidays(collaborator, 1)}
                          {_("day").substring(0, 1)}
                          {collaborator.holidayTypes.length > 1 ? (
                            <Tooltip
                              placement="right"
                              title={
                                <div>
                                  {collaborator.holidayTypes.map(
                                    (item, l) =>
                                      item.id !== 1 ? (
                                        <p
                                          key={l}
                                          style={{
                                            textAlign: "left",
                                            margin: "auto"
                                          }}
                                        >
                                          {"- " +
                                            item.label +
                                            " : " +
                                            item.nbrOfDays}
                                          {_("day").substring(0, 1)}
                                        </p>
                                      ) : (
                                        ""
                                      )
                                  )}
                                </div>
                              }
                            >
                              {" "}
                              <img
                                src="/img/icons/info.svg"
                                alt="text"
                                style={{ cursor: "pointer" }}
                              />{" "}
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className={classnames("row", styles.total_frame)}>
                        <div className={styles.label}>
                          {_("total")}:{" "}
                          {this.handleCalculateHolidays(collaborator, null)}
                          {_("day").substring(0, 1)}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {!collaborator.isFreelancer
                            ? _("Heures/semaine")
                            : // ? _("nbrWeeks")
                              _("total")}:{" "}
                          {collaborator &&
                          collaborator.capacity &&
                          collaborator.capacity.hrForWeek
                            ? // eslint-disable-next-line radix
                              parseInt(collaborator.capacity.hrForWeek) + "H"
                            : "0"}
                        </div>
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        {!collaborator.isFreelancer && (
                          <div className={styles.label}>
                            {_("nbrWeeks")}: {/*{_("RHHebdo")}:{" "}*/}
                            {collaborator &&
                            collaborator.capacity &&
                            collaborator.capacity.nbrOfWeeks
                              ? // eslint-disable-next-line radix
                                parseInt(collaborator.capacity.nbrOfWeeks)
                              : "0"}
                          </div>
                        )}
                      </div>
                      <div className={classnames("row", styles.total_frame)}>
                        {!collaborator.isFreelancer && (
                          <div className={styles.label}>
                            {_("total")}:{" "}
                            {collaborator.capacity.hrForWeek *
                              collaborator.capacity.nbrOfWeeks +
                              "H"}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("specialProject")}:{" "}
                          {collaborator &&
                          collaborator.capacity &&
                          collaborator.capacity.nfSpecialProject
                            ? collaborator.capacity.nfSpecialProject
                            : "0"}
                        </div>
                      </div>
                      <div className={classnames("row", styles.select_frame)}>
                        <div className={styles.label}>
                          {_("basicNFH")}:{" "}
                          {collaborator &&
                          collaborator.capacity &&
                          collaborator.capacity.hrNF
                            ? collaborator.capacity.hrNF
                            : "0"}
                        </div>
                      </div>
                      <div className={classnames("row", styles.total_frame)}>
                        <div className={styles.label}>
                          {_("total")}:{" "}
                          {(collaborator &&
                          collaborator.capacity &&
                          collaborator.capacity.hrNF
                            ? parseInt(collaborator.capacity.hrNF, 10)
                            : 0) +
                            parseInt(
                              collaborator &&
                              collaborator.capacity &&
                              collaborator.capacity.nfSpecialProject > 0
                                ? collaborator.capacity.nfSpecialProject
                                : 0,
                              10
                            )}
                        </div>
                      </div>
                    </td>
                    <td
                      style={{
                        background: k % 2 ? "#f8f9fa" : "#f5f6f7",
                        position: "sticky",
                        right: "0px",
                        zIndex: "2"
                      }}
                    >
                      <Button
                        type={"success"}
                        style={{
                          height: 35,
                          marginRight: 5,
                          padding: "0px 13px",
                          background: "white",
                          color: "#6D7F92"
                        }}
                        onClick={e =>
                          this.handleDisplayUpdateCollaboratorModal(
                            collaborator
                          )
                        }
                      >
                        <PencilIcon fill="#3C4E64" />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  renderCollaboratorsSettingYearSelect = () => {
    const { yearDivIsVisible, year } = this.state;

    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() =>
                    this.handleCollaboratorsSettingSelectYear(item)
                  }
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleClickOutsideYearSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  handleCollaboratorsSettingSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({
      year: year,
      yearDivIsVisible: false
    });
    dispatch(fetchSettingCollaborators(year));
    dispatch(initCapacityPlaningProduction());
  };

  handleUpdateCollaborator = collaborator => {
    const { year } = this.state;
    this.setState({ loadingUpdateCollaborator: true });
    this.props.dispatch(updateSettingsCollaborator(collaborator, year)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("collaboratorUpdated")
        });
        this.props.dispatch(fetchSettingCollaborators(year));
        this.props.dispatch(initCapacityPlaningProduction());
        this.setState({
          selectedCollaborator: null,
          loadingUpdateCollaborator: false,
          isUpdateCollaboratorModalVisible: false
        });
      },
      err => {
        console.log({ err });
        onError(err.response.data.errors[0].message);
      }
    );
  };

  renderCollaboratorListCallout = error => {
    switch (error.code) {
      case 170010:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("noOrganization")}
            buttonIgnored={this.props.embedded}
          />
        );
      case 170040:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("error1")}
            buttonIgnored={this.props.embedded}
          />
        );
      default:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={_("errorOccured")}
            buttonIgnored={this.props.embedded}
          />
        );
    }
  };

  handleDisplayUpdateCollaboratorModal = collaborator => {
    const { settingSuggestions, erpData } = this.props;
    let erpCollaborators = erpData && erpData.items.collaborators;
    const dataErp = erpCollaborators ? erpCollaborators : [];
    let erpId = 0;
    let erpLabel = "";

    console.log("TEST", { collaborator });

    erpData.fetched &&
      dataErp.forEach(erp => {
        if (erp[collaborator.id] && erp[collaborator.id].erpId) {
          erpId = erp[collaborator.id].erpId;
          erpLabel = erp[collaborator.id].erpLabel;
        }
      });
    this.setState({
      isUpdateCollaboratorModalVisible: true,
      selectedCollaborator: {
        collaboratorName: collaborator.name,
        profile: collaborator.profile,
        partner: collaborator.partner,
        erpId: erpId,
        erpLabel: erpLabel,
        arrivalDate: collaborator.arrivalDate,
        departureDate: collaborator.departureDate,
        bu: collaborator.bu,
        nfSpecialProject: collaborator.capacity.nfSpecialProject,
        id: collaborator.id,
        name: collaborator.name,
        regime: collaborator.regime,
        backup: collaborator.backup,
        openDays: collaborator.openDays,
        workingHours: {
          monday: collaborator.workingHours.monday,
          tuesday: collaborator.workingHours.tuesday,
          wednesday: collaborator.workingHours.wednesday,
          thursday: collaborator.workingHours.thursday,
          friday: collaborator.workingHours.friday
        },
        isOfficeWorkPlace: collaborator.isOfficeWorkPlace,
        regimeSelected:
          settingSuggestions.data.regimes &&
          settingSuggestions.data.regimes.find(
            obj => obj.id === collaborator.regime
          ),
        holidayTypes: collaborator.holidayTypes,
        role: collaborator.role,
        zone: collaborator.zone,
        year: this.state.year,
        nbrOfRecoveredAnnualHolidays: collaborator.nbrOfRecoveredAnnualHolidays
      }
    });
  };

  handleDisplayLocalizationModal = () => {
    this.setState({
      isLocalizationModalVisible: true
    });
  };

  handleDisplayRegimeModal = () => {
    this.setState({
      isRegimeModalVisible: true
    });
  };

  // handleDisplayRoleModal = () => {
  //   this.setState({
  //     isRoleModalVisible: true
  //   });
  // };
  handleDisplayHolidayTypeModal = () => {
    this.setState({
      isHolidayTypeModalVisible: true
    });
  };

  handleCancelUpdateCollaborator = () => {
    this.setState({
      isUpdateCollaboratorModalVisible: false
    });
  };

  handleCancelLocalizationModal = () => {
    this.setState({
      isLocalizationModalVisible: false
    });
  };

  handleCancelRegimeModal = () => {
    this.setState({
      isRegimeModalVisible: false
    });
  };

  handleCancelRoleModal = () => {
    this.setState({
      isRoleModalVisible: false
    });
  };

  handleCancelHolidayTypeModal = () => {
    this.setState({
      isHolidayTypeModalVisible: false
    });
  };

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  render() {
    const {
      fetching,
      nbResult,
      settingSuggestions,
      collaboratorData,
      filteredData,
      filter
    } = this.props;
    const data = filteredData ? filteredData : [];

    return (
      <div className={styles.page_content}>
        <SettingPageHeader
          title={_("collaboratorsSettings")}
          onBack={() => this.handleRedirectBack()}
        />
        <div className={styles.block_content}>
          <div className={styles.title_block}>
            <h2 className={styles.title}>{_("collaboratorList")}</h2>
            <h3 className={styles.subtitle}>
              {_("ManageTheCollaboratorsInformation")}
            </h3>
            <CollaboratorSettingFilter
              filter={filter}
              data={collaboratorData}
              filteredData={data}
              filterFormIsVisible={this.handleFilterFormIsVisible}
              nbResult={nbResult}
              fetching={this.props.fetching}
            />
            {this.renderCollaboratorsSettingYearSelect()}
          </div>
          {/*{error && this.renderCollaboratorListCallout(error)}*/}
          <div>
            {fetching || settingSuggestions.fetching ? (
              <div className={styles.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            ) : (
              this.renderCollaboratorList()
            )}
          </div>
          <TTPModal
            visible={this.state.isUpdateCollaboratorModalVisible}
            footer={null}
            width={982}
          >
            <UpdateCollaboratorContent
              onCancel={this.handleCancelUpdateCollaborator}
              collaborator={this.state.selectedCollaborator}
              loading={this.state.loadingUpdateCollaborator}
              onSave={this.handleUpdateCollaborator}
              saving={this.props.saving}
              collaborators={collaboratorData}
            />
          </TTPModal>
          <TTPModal
            visible={this.state.isRegimeModalVisible}
            footer={null}
            width={1000}
          >
            <RegimeSettingContent
              onCancel={this.handleCancelRegimeModal}
              collaboratorData={this.props.collaboratorData}
              loading={this.state.loading}
            />
          </TTPModal>
          {/* <TTPModal
            visible={this.state.isRoleModalVisible}
            footer={null}
            width={900}
          >
            <RoleSettingContent
              onCancel={this.handleCancelRoleModal}
              loading={this.state.loading}
            />
          </TTPModal> */}
          <TTPModal
            visible={this.state.isHolidayTypeModalVisible}
            footer={null}
            width={900}
          >
            <HolidayTypesSettingContent
              onCancel={this.handleCancelHolidayTypeModal}
              loading={this.state.loading}
            />
          </TTPModal>
          <TTPModal
            visible={this.state.isLocalizationModalVisible}
            footer={null}
            width={900}
          >
            <LocalizationSettingContent
              onCancel={this.handleCancelLocalizationModal}
              loading={this.state.loading}
            />
          </TTPModal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.collaborator.fetching,
  fetched: state.collaborator.fetched,
  saving: state.collaborator.saving,
  error: state.collaborator.error,
  breadCrumb: state.params.breadCrumb,
  collaboratorData: state.collaborator.collaboratorsData,
  filteredData: state.collaborator.filteredCollaboratorsData,
  filter: state.collaborator.filter,
  nbResult:
    state.collaborator.collaboratorsData &&
    state.collaborator.collaboratorsData.length,
  erpData: state.erpData.data,
  settingSuggestions: state.collaborator.settingSuggestions,
  currentOrganization: state.auth.currentOrganization,
  users: state.users && state.users.data ? state.users.data : [],
  currentOrganization: state.auth.currentOrganization
});

export default connect(mapStateToProps)(CollaboratorSetting);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSetting/CollaboratorSetting.js